import { AdmissionGroup } from '@domain/admission-group';
import { EventSection } from '@domain/event-section';

import { MoveOfferType } from '../../../hooks/admissions/use-move-offer';

type ContainerWithItems = {
  id: string;
  items: Array<{ position: number }>;
};

/**
 * Normalizes positions in a container (section or group) to be incremental from 1 to N
 */
const normalizeContainerPositions = <T extends ContainerWithItems>(containers: T[], containerId: string): void => {
  const container = containers.find((x) => x.id === containerId);
  if (container) {
    for (let i = 0; i < container.items.length; i++) {
      container.items[i].position = i + 1;
    }
  }
};

/**
 * Normalizes positions for groups after a move operation
 */
export const normalizePositions = (
  groups: AdmissionGroup[],
  from: { type: MoveOfferType; id: string },
  to: { type: MoveOfferType; id: string }
): void => {
  // solo aplica si el contenedor afectado es un group
  if (from.type === 'offer_group') {
    normalizeContainerPositions(groups, from.id);
  }

  // evita doble trabajo si es el mismo contenedor
  if (to.type === 'offer_group' && to.id !== from.id) {
    normalizeContainerPositions(groups, to.id);
  }
};

/**
 * Normalizes positions for sections after a move operation
 */
export const normalizeSectionPositions = (
  sections: EventSection[],
  from: { type: MoveOfferType; id: string },
  to: { type: MoveOfferType; id: string }
): void => {
  // solo aplica si el contenedor afectado es una section
  if (from.type === 'section') {
    normalizeContainerPositions(sections, from.id);
  }

  // evita doble trabajo si es el mismo contenedor
  if (to.type === 'section' && to.id !== from.id) {
    normalizeContainerPositions(sections, to.id);
  }
};
